/* eslint-disable react/jsx-pascal-case */
import { traceEvent } from '@wk/wk-gatherer';
import router from 'next/router';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateEffect } from 'react-use';

import Mobile from '@/components/Device/Mobile';
import PC from '@/components/Device/PC';
import List from '@/components/List';
import NoData from '@/components/NoData';
import WkPagination from '@/components/WkPagination';
import useIsMaxScreen from '@/hooks/useIsMaxScreen';
import useIsPc from '@/hooks/useIsPC';

import ResourceItem from '../../Common/ResourceItem';
import ResourceContext from '../../context';
import { Resource, RootMenu } from '../../types';
import { convertReSourceList } from '../../utils';
import Questions from '../Questions';

interface Props {
  menuData?: RootMenu[];
  getResourceList: (dataList: Resource[]) => void;
}

const ContentList: FC<Props> = ({ menuData, getResourceList }) => {
  const { query, setQueryAndUpdatePath, resourceList, filterTags } =
    useContext(ResourceContext);
  const dataList = convertReSourceList(resourceList?.content?.content || []);
  const { t } = useTranslation('resources');
  const isPc = useIsPc();
  const { subject } = router.query;
  const isMaxScreen = useIsMaxScreen();

  useUpdateEffect(() => {
    if (!dataList?.length) {
      return;
    }
    traceEvent({
      data: {
        _event: 'O_LearningWorldList_MaterialItemExpose',
        material_id: dataList.map(data => data.id),
        Filter_criteria: JSON.stringify({
          ...query,
          menus: filterTags,
          subject,
        }),
      },
    });
    getResourceList(dataList);
  }, [dataList]);

  return (
    <div className="lg:w-[calc(100%-224px) w-full xl:w-[calc(100%-245px)]">
      {dataList?.length ? (
        <div className="relative">
          <List
            itemStyle={{ width: 231 }}
            items={dataList?.map?.(item => ({
              key: item.id,
              value: (
                <>
                  <PC>
                    <ResourceItem
                      {...item}
                      width={231}
                      coverWidth={231}
                      coverHight={isMaxScreen ? 148.5 : 129.938}
                      eventName="O_LearningWorldList_ResourcemCardClick"
                    />
                  </PC>
                  <Mobile>
                    <ResourceItem
                      {...item}
                      width="calc(100vw - 2.5rem)"
                      coverWidth={335}
                      coverHight={188}
                      eventName="O_LearningWorldList_ResourcemCardClick"
                    />
                  </Mobile>
                </>
              ),
            }))}
          />
          <div className="text-center mobile:mt-[32px] pc:mt-[48px]">
            <WkPagination
              simple={!isPc}
              pageSize={resourceList?.content?.pageSize || 12}
              current={Number(query?.page || 1)}
              total={resourceList?.content?.totalCount || 1}
              onChange={current => {
                window.scrollTo({
                  top: isPc ? 300 : 320, // 滚动到距离顶部 500 像素的位置
                  behavior: 'smooth', // 平滑滚动
                });
                setTimeout(() => {
                  setQueryAndUpdatePath({ page: current.toString() });
                }, 1000);
              }}
            />
          </div>
        </div>
      ) : (
        <div className="relative h-[624px]">
          <NoData text={t('暂无相关资源')} />
        </div>
      )}
      <Questions menuData={menuData} />
    </div>
  );
};

export default ContentList;
